<script>
import Modal from '@/components/atoms/Modal'
import ModalLogin from '@/components/organism/modal/ModalLogin'
import FormValidation from '@/components/atoms/FormValidation'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import InputPhone from '@/components/atoms/inputlib/components/InputPhone'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import auth from '@/modules/mixins/auth'
import { mapGetters } from 'vuex'

export default {
    name: 'CheckoutAuthentication',
    components: {
        ButtonLoader,
        InputPhone,
        InputCheckbox,
        InputLine,
        FormValidation,
        ModalLogin,
        Modal,
    },
    mixins: [auth],
    props: {
        filteredAddresses: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters({
            activeCanteen: 'active/canteen',
            orderAddress: 'order/address',
        }),
        user() {
            return this.$user
        },
        isLoggedIn() {
            return this.user.isLoggedIn
        },
    },
    methods: {
        async auth() {
            try {
                await this.register(false)
                if (this.activeCanteen.isResidential) this.$emit('authenticated')
                else this.$location.add.open(this.orderAddress, undefined, false, false)
                this.$cart.setPhone(this.user.model, this.orderAddress)
                await this.$store.dispatch('checkout/stripeInitAfterLogin')
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Error during registration:', e)
            }
        },
        login() {
            if (!this.$cart.loading) this.$refs.login.open()
        },
    },
}
</script>

<template lang="pug">
.card.checkout-authentication(v-if="!isLoggedIn")
    .card-header.d-flex.align-items-center.flex-wrap.justify-content-between
        h2.mb-0 {{$t('login.sign_up')}}
        .d-flex.align-items-center.ml-auto
            span.mr-2.mr-md-5 {{$t('login.existing_user')}}
            button.btn.btn-primary.btn-xs(@click="login"  ) {{$t('login.log_in')}}
    .card-body
        form-validation(@submit="auth")
            .form-row
                .col-12.col-lg-6
                    input-line(v-model="model.first_name" type="alpha" validate="first_name" required live) {{$t('labels.first_name')}}
                .col-12.col-lg-6
                    input-line(v-model="model.last_name" type="alpha" validate="last_name" required live) {{$t('labels.last_name')}}
            .form-row
                .col-12.col-lg-6
                    input-line(v-model="model.email" type="email" autocomplete="off" validate='email' required live) {{$t('labels.email')}}
                .col-12.col-lg-6
                    input-phone(v-model="model.phone" type="phone" validate='phone' required live) {{$t('labels.phone')}}
            .form-row
                .col-12.col-lg-6
                    input-line(v-model="model.plain_password" type="password" validate='plain_password' autocomplete="new-password" :min="8" :max="300" required same live) {{$t('labels.psw')}}
                .col-12.col-lg-6
                    input-line(v-model="psw" type="password" :min="8" :max="300" autocomplete="new-password" :same="$t('labels.error.psw')" required live) {{$t('labels.re_psw')}}
            input-checkbox.d-flex.mb-4.mb-lg-2(v-model="acceptTerms" :content="$t('base.accept.terms', {link: terms})" required)
            input-checkbox.d-flex.mb-4.mb-lg-2(v-model="acceptPrivacy" :content="$t('base.accept.privacy', {link: privacy})" required)
            input-checkbox.d-flex(v-model="model.is_subscribed_for_newsletter" :content="$t('base.accept.newsletter')")
            template(v-slot:submit)
                button-loader.btn.btn-primary.btn-block.mt-5.mb-8(type="submit" :disabled="$cart.loading" :loading="loading" inline) {{$t('login.sign_up')}}
    modal-login(ref="login" :filtered-addresses="filteredAddresses")
</template>
